<template lang="pug">
GlobalDialog(
    v-model="displayModal"
    scrollable
    :showRButton="false"
    :showLButton="false"
    :showMButton="false"
    :headerTitle="$t('snapshots.history')"
    max-width="1363px"
  )
    template(slot='content')
     v-data-table(
       :headers="headers"
       :items="history"
       hide-default-footer
     )
      template(v-slot:item.updatedAt="{ item }") {{ formatDate(item) }}
      template(v-slot:item.text="{ item }") <span v-html="item.text"></span>
</template>

<script>
import GlobalDialog from '@/components/Reuse/GlobalDialog.vue'
import moment from 'moment'
import { selectedLocale } from '@/plugins/i18n'

export default {
  components: {
    GlobalDialog
  },
  computed: {
    displayModal: {
      get () {
        return this.showModal
      },
      set (value) {
        this.$emit('update:showModal', value)
      }
    }
  },
  data () {
    return {
      headers: [
        {
          text: this.$t('commonWords.updatedAt'),
          align: 'center',
          sortable: false,
          width: '200px',
          value: 'updatedAt'
        },
        {
          text: this.$t('commonWords.updatedBy'),
          align: 'center',
          sortable: false,
          width: '200px',
          value: 'updatedBy.name'
        },
        {
          text: this.$t('snapshots.assistantResponse'),
          align: 'start',
          sortable: false,
          value: 'text'
        }
      ]
    }
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    history: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    formatDate (item) {
      return moment(item.updatedAt).locale(selectedLocale).format('L LT')
    }
  }
}
</script>
